import React from "react";
import { ReactComponent as PassThrough } from "./../images/passThrough.svg";
import { ReactComponent as TierePricing } from "./../images/tieredPricing.svg";
import { ReactComponent as FlatPricing } from "./../images/flatPricing.svg";
import { ReactComponent as DuelPricing } from "./../images/duelPricing.svg";

function PricingOptionIcon(product: any) {
  let selectedLogo;

  if (product.productName == "Pass-through Plus Pricing") {
    selectedLogo = <PassThrough />;
  } else if (product.productName == "Tiered Pricing") {
    selectedLogo = <TierePricing />;
  } else if (product.productName == "Flat Pricing") {
    selectedLogo = <FlatPricing />;
  } else if (product.productName == "Duel Pricing") {
    selectedLogo = <DuelPricing />;
  } else {
    selectedLogo = "--";
  }
  return <div className="productIcon">{selectedLogo}</div>;
}

export default PricingOptionIcon;


